import { Button, Offcanvas, OffcanvasBody } from "react-bootstrap";
import { BsChat } from "react-icons/bs";
import styled from "styled-components";
import Notification from "./A03_Notification";
import { CreateTooltip, toDecimal } from "../../core/Helper";
import { BiRightArrow, BiTrash } from "react-icons/bi";

const styles = {
  messageBar: {
    background: "#141414",
    width: "400px",
  },
};

export const MessageOffCanvas = (props) => {
  const [messageBar, setMessageBar] = props.messageBar;
  const [messages, setMessages] = props.messages;
  const [deleting, setDeleting] = props.deleting;
  const { handleOnlieBar, handleConfirm, styles } = props;
  return (
    <Offcanvas
      show={messageBar}
      placement="end"
      onHide={handleOnlieBar}
      style={styles.messageBar}
    >
      <Offcanvas.Header style={styles.messageBarHeader}>
        <Offcanvas.Title style={styles.messageBarHeader}>
          <BsChat style={{ margin: "10px" }} />
          การแจ้งเตือน
          <SpanMessages>
            {messages.length > 0
              ? `${toDecimal(messages.length, 0)} ข้อความ`
              : "ไม่พบข้อความ"}{" "}
          </SpanMessages>
        </Offcanvas.Title>

        {CreateTooltip(
          "ลบทั้งหมด",
          <Button
            variant="danger"
            style={{ marginRight: "3px" }}
            onClick={() => handleConfirm()}
          >
            {/* {deleting ? <Oval size={10} /> : <BiTrash />}  */}
            <BiTrash />
          </Button>
        )}

        <Button
          onClick={() => {
            setMessageBar(false);
          }}
        >
          <BiRightArrow />
        </Button>
      </Offcanvas.Header>
      <OffcanvasBody>
        <div style={styles.messagebarBody}>
          <Notification
            {...{
              messageBar: [messageBar, setMessageBar],
              messages: [messages, setMessages],
              deleting: [deleting, setDeleting],
            }}
          />
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

const SpanMessages = styled.div`
  color: wheat;
  margin-inline: 5px;
  font-size: 12px;
`;
